export const commands = {
  help: "Displays this help message",
  clear: "Clears the terminal",
  ls: "Lists files in the current directory",
  cd: "Changes directory",
  cat: "Displays the content of a file",
};
